import script from "./McnAskfor.vue?vue&type=script&setup=true&lang=js"
export * from "./McnAskfor.vue?vue&type=script&setup=true&lang=js"

import "./McnAskfor.vue?vue&type=style&index=0&id=1dc7c5f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dc7c5f8"]])

export default __exports__